import { render, staticRenderFns } from "./locate-historys.vue?vue&type=template&id=06dc866c&scoped=true"
import script from "./locate-historys.vue?vue&type=script&lang=js"
export * from "./locate-historys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dc866c",
  null
  
)

export default component.exports